import { computed, Ref, ref, watch } from '@vue/composition-api';
import { useStore, StateEnum, useHooksCache, defineHooks, DefineHookName, useSharedAreaStore } from '@tt4b/ttam-hooks';
import { uniq, uniqBy } from 'lodash-es';
import { AreaItem, AreaStatus } from '@tt4b/ttam-enums';

/**
 * 获取定向国家信息
 * @returns
 */
function _useLocationTargetingDataSource() {
  const { state } = useStore();
  const areaData = state[StateEnum.areaData].data;
  const { setAppendedArea, getAppendedArea } = useSharedAreaStore();

  const unsupportedCountriesIds = computed(() => areaData?.value?.unsupportedCountryIds ?? []);
  const virtualNodeIdParentIdMap = computed(() => areaData?.value?.virtualNodeIdParentIdMap ?? []);

  const areaMap = computed(() => areaData?.value?.areaMap ?? {});
  const areaList = computed(() => areaData?.value?.areaList ?? []);
  const allUnsupportedLocationIds = computed(() => areaData?.value?.allUnsupportedLocationIds ?? []);

  function resetLocationData() {
    setAppendedArea({
      locationList: [],
      locationInfoMap: {},
      unsupportedLocationIds: [],
    });
  }

  function updateLocationData(options: { list: AreaItem[]; map: Record<number, AreaItem> }) {
    const { list, map = {} } = options;
    if (!list.length || !Object.keys(map).length) {
      return;
    }

    const appendedArea = getAppendedArea();
    setAppendedArea({
      locationList: uniqBy([].concat(appendedArea.value.locationList, list), 'id'),
      locationInfoMap: Object.assign({}, appendedArea.value.locationInfoMap, map),
      unsupportedLocationIds: uniq([
        ...(appendedArea.value.unsupportedLocationIds || []),
        ...list?.filter(item => item?.status === AreaStatus.OFFLINE).map(item => item.id),
      ]),
    });
  }

  function updateOfflineAreaTipsVisibleState(hasSelectedOfflineAreas) {
    setAppendedArea({
      hasSelectedOfflineAreas,
    });
  }
  return {
    areaMap,
    areaList,
    unsupportedCountriesIds,
    allUnsupportedLocationIds,
    virtualNodeIdParentIdMap,
    resetLocationData,
    updateLocationData,
    updateOfflineAreaTipsVisibleState,
  };
}
export const useLocationTargetingDataSource = defineHooks(
  DefineHookName.useLocationTargetingDataSource,
  _useLocationTargetingDataSource,
);
